
import { Vue, Component, Prop } from "vue-property-decorator";

import FormInput from "@/components/form/FormInputNew.vue";

@Component({
  components: {
    FormInput,
  },
})
export default class FormInputGroup extends Vue {
  @Prop({ type: String, default: undefined }) readonly inputClasses?: string;
   @Prop({ type: String, default: "" }) readonly inputClass?: string;
    @Prop({ type: String, default: "" }) readonly iconStyle!: string;
  @Prop({ type: String, default: undefined }) readonly prefix?: string;
  @Prop({ type: String, default: undefined }) readonly svgPrefix?: string;
  @Prop({ type: String, default: undefined }) readonly suffix?: string;
  @Prop({ type: Boolean, default: false }) readonly withIcon?: boolean;
  @Prop({ type: String, default: undefined }) readonly height?: string;
}
